// extracted by mini-css-extract-plugin
export default {"tabs":"Navi_tabs__xR6bx","tab":"Navi_tab__V20sf","activeTab":"Navi_activeTab__PQMHp"};